import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { reduxKey } from './constants';
import { handleActions } from 'redux-actions';
import { initFlags, setFlags } from './actions';
import { addCalculatedFlags } from '@wix/da-react-context/pkg/flags/helpers';
const actionHandlers = handleActions({
    [initFlags.toString()]: (state, { payload: { flags  }  })=>addCalculatedFlags(flags),
    [setFlags.toString()]: (state, { payload: { flags  }  })=>addCalculatedFlags(_object_spread({}, state, flags))
}, {});
export default {
    [reduxKey]: actionHandlers
};
